const PREFIX = 'trigger_form'
const SEPARATOR = '__'

export function buildKey(elementId: string | number): string {
  return `${PREFIX}${SEPARATOR}${elementId}`
}

export function parseKey(name: string): string | null {
  if (!name.startsWith(`${PREFIX}${SEPARATOR}`)) return null

  const referenceId = name.slice(PREFIX.length + SEPARATOR.length)
  return referenceId || null
}
